import { ContatoWA } from "services/api/AppWeb_WhatsApp/types";

export type WhatsAppTab = "conversas" | "massa" | "historico";
export type SendHistoryType = "INDIVIDUAL" | "CAMPANHA";
export type SendHistoryStatus = "ENVIADA" | "ENTREGUE" | "LIDA" | "ERRO";

export interface SendHistoryEntry {
  id: string;
  leadId: string;
  leadNome: string;
  mensagem: string;
  tipo: SendHistoryType;
  status: SendHistoryStatus;
  dataHora: string;
  dataHoraSort?: string;
  arquivosUrl?: string[];
  qtdTotal?: number;
  qtdEnviado?: number;
  qtdPendente?: number;
  qtdErro?: number;
}

export interface SendHistoryPayload {
  leadId: string;
  leadNome: string;
  mensagem: string;
  tipo: SendHistoryType;
  status?: SendHistoryStatus;
}

const HISTORY_KEY = "wa_send_history_v2";

export const TEMPLATE_TOKENS = [
  "{Nome}",
  "{Produto}",
  "{Corretor}",
  "{Empresa}",
];

export function contatoId(c: ContatoWA): string {
  return c.leadCorretorId || c.rowKey || c.id || "";
}

// Chave única por linha do contato (rowKey do Azure Table Storage).
// Necessário porque vários contatos podem compartilhar o mesmo
// leadCorretorId (lead com mais de um telefone), e contatoId() não
// distingue entre eles — provoca colisão de React keys e em buscas
// `.find()` por id.
export function contatoRowId(c: ContatoWA): string {
  return c.rowKey || c.id || c.leadCorretorId || c.telefone || "";
}

export function loadHistory(): SendHistoryEntry[] {
  try {
    const raw = localStorage.getItem(HISTORY_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function saveHistory(entries: SendHistoryEntry[]): void {
  localStorage.setItem(HISTORY_KEY, JSON.stringify(entries));
}
